import { createFileRoute } from "@tanstack/react-router";
import ItRunsInMyFamily from "@/pages/articles/ItRunsInMyFamily";
export const Route = createFileRoute(
  "/it-runs-in-my-family-what-that-means-for-your-depression",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Depression Runs in My Family | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "If depression runs in your family, learn what that means for your risk and treatment options like TMS and SAINT TMS in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content: "Depression Runs in My Family | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "If depression runs in your family, learn what that means for your risk and treatment options like TMS and SAINT TMS in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/it-runs-in-my-family-what-that-means-for-your-depression",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/it-runs-in-my-family-what-that-means-for-your-depression",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <ItRunsInMyFamily />;
}
